import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getFarmNameTuples } from "../../../pages/map-page/store/map-page.selector";
import { fetchAvailableFarmsAction } from "../../../pages/map-page/store/map-page.slice";
import { useAppDispatch } from "../../../store";

export type AvailableFarmsStatus = "idle" | "loading" | "empty" | "ready";

/**
 * Проверяет, что у пользователя есть хозяйства. «Пусто» — только успешно полученный
 * пустой список; ошибка загрузки пропускает в приложение, как и раньше, — её
 * показывает сам фильтр хозяйств, а не страница «Нет назначенных хозяйств».
 */
export function useAvailableFarmsGate(enabled: boolean): {
  status: AvailableFarmsStatus;
  retry: () => void;
} {
  const dispatch = useAppDispatch();
  const hasFarms = useSelector(getFarmNameTuples).length > 0;
  const [status, setStatus] = useState<AvailableFarmsStatus>("idle");

  const check = useCallback(() => {
    setStatus("loading");
    dispatch(fetchAvailableFarmsAction())
      .unwrap()
      .then((farmCount) => setStatus(farmCount === 0 ? "empty" : "ready"))
      .catch(() => setStatus("ready"));
  }, [dispatch]);

  useEffect(() => {
    if (enabled && !hasFarms && status === "idle") {
      check();
    }
  }, [enabled, hasFarms, status, check]);

  if (!enabled) {
    return { status: "idle", retry: check };
  }
  return { status: hasFarms ? "ready" : status, retry: check };
}
